import styled from "styled-components"; 

export const ContainerPreguntarCentro = styled.div`
    
    margin-top: 20px;
    height: calc(100vh - 250px);
    display: flex;
    flex-direction: column;
    button {
        margin: 0;
    }
    justify-content: flex-start;
    align-items: center;
    gap: 30px;
    padding-top: 30px;
    overflow-y: scroll;
    ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: var(--color-scrollbar);
  }
  .ptur-socialSidebar-burguer {
    width: 100%;
    position: initial;
    padding-top: 20px;
  }
  svg {
    width: 25px;
    height: 25px;
  }
`;